import React from 'react';
import { JobCategoryManagement } from '@/components/jobCategory';

export const JobCategoriesPage: React.FC = () => {
  return <JobCategoryManagement />;
};